import styled from 'styled-components'

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
  appearance: none;
  background: white;
  outline: none;
  position: relative;

  &:checked {
    background-color: #4caf50;
    border-color: #4caf50;

    &::after {
      content: '✓';
      color: white;
      font-size: 11px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`

export const TaskRow = styled.div`
  display: grid;
  grid-template-columns: 24px 2fr 1fr 1fr 1fr 1fr auto;
  gap: 12px;
  padding: 12px 16px;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  width: 100%;
  box-sizing: border-box;

  & > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  ${props =>
    props.$completed &&
    `
     color: #999;
     background-color: #fafafa;

     & ${Checkbox} {
       background-color: #4CAF50;
       border-color: #4CAF50;

       &::after {
         content: '✓';
         color: white;
         font-size: 11px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
       }
     }
   `}
`

export const DueDate = styled.span`
  color: ${props => (props.$isOverdue ? '#f44336' : 'inherit')};
`

export const TaskNameCell = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 20px;

  &:hover {
    color: #2196f3;

    &::after {
      content: '→';
      position: absolute;
      right: 0;
      opacity: 1;
    }
  }

  &::after {
    content: '→';
    position: absolute;
    right: 0;
    opacity: 0;
    transition: opacity 0.2s ease;
    color: #2196f3;
  }
`
